"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SchedulerNoteSection = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const labels_1 = __importDefault(require("@/app/shared/i18n/labels"));
const scheduler_1 = require("@/app/SUMOCEP/store/scheduler");
const inputtextarea_1 = require("primereact/inputtextarea");
const react_redux_1 = require("react-redux");
const SchedulerNoteSection = () => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const noteFromHost = (0, react_redux_1.useSelector)(scheduler_1.schedulerSelectors.selectNoteFromHost);
    const handleNoteFromHostChange = (noteFromHost) => {
        dispatch(scheduler_1.SUMOCEPSchedulerActions.updateBookingPageWhat({ noteFromHost }));
    };
    return ((0, jsx_runtime_1.jsxs)("div", { className: 'flex flex-column gap-8px', children: [(0, jsx_runtime_1.jsx)("div", { className: 'text-label-s-med text-gray-80', children: labels_1.default.SCHEDULER_NOTE_LABEL }), (0, jsx_runtime_1.jsx)(inputtextarea_1.InputTextarea, { value: noteFromHost, rows: 3, autoResize: true, onChange: (e) => handleNoteFromHostChange(e.target.value) })] }));
};
exports.SchedulerNoteSection = SchedulerNoteSection;
